<template>
  <ELocalBusinessesWidget
    v-if="showWidget"
    v-bind="$props"
  />
</template>

<script>
export default {
  name: 'ELocalBusinesses',
  components: {
    ELocalBusinessesWidget: async () => import(
      /* webpackChunkName: "local-businesses-widget" */
      './widget.vue'
    ),
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    showWidget() {
      return this.items.length > 0;
    },
  },
};
</script>
